

import React, { Component } from 'react';
import _ from 'lodash'
import { decode } from 'he'
import { Table } from 'react-bootstrap'

import $ from 'jquery';

import { getFromDrupalAPI, searchDrupalSermons } from '../fetchJSON.js'

class Sermons extends Component {

  constructor() {
    super();
    this.state = {
      sermons: null,
      page: 0,
      sermonSeries: null,
      viewingRefinedList: false,
      sermonPages: null,
      totalSermons: null,
      searchQuery: "",
      searchType: "title"
    }
  }

  componentWillMount() {
    var that = this;

    getFromDrupalAPI('all_sermon_series_api', function (data) {
      that.setState({ sermonSeries: data })
    });

    getFromDrupalAPI('all_sermons_api?limit=20', function (data) {
      that.setState({ sermons: data })
    });

    //get count of total sermons for pages
    getFromDrupalAPI('all_sermons_api', function (data) {
      var pages = Math.floor(data.length / 20) + 1
      that.setState({ totalSermons: data.length, sermonPages: pages })
    });
  }

  loadNextSermons(page) {
    var that = this;
    var offset = (page + 1) * 20
    this.setState({ sermons: null, page: page + 1 })
    getFromDrupalAPI('all_sermons_api?offset=' + offset + '&limit=20', function (data) {
      that.setState({ sermons: data, viewingRefinedList: false })
    });

  }

  loadPreviousSermons(page) {
    var that = this;
    var offset = (page - 1) * 20

    if (this.state.viewingRefinedList === true) {
      $("#sermonSelect").val("");
    }

    this.setState({ sermons: null, page: page - 1 })
    getFromDrupalAPI('all_sermons_api?offset=' + offset + '&limit=20', function (data) {
      that.setState({ sermons: data, viewingRefinedList: false })
    });


  }

  loadSermonSeries(sermonSeriesNid) {
    var that = this;
    getFromDrupalAPI('all_sermons_api?filters[sermonSeries]=' + sermonSeriesNid, function (data) {
      that.setState({ sermons: data, viewingRefinedList: true })
    });
  }

  searchSermons(e) {
    var that = this;
    if (this.state.searchQuery && this.state.searchQuery !== "") {
      searchDrupalSermons(this.state.searchQuery, this.state.searchType, function (data) {
        that.setState({ sermons: data, viewingRefinedList: true })
      });
    }

    e.preventDefault();
  }

  updateSearchQuery(event) {
    this.setState({ searchQuery: event.target.value });
  }

  updateSearchType(event) {
    this.setState({ searchType: event.target.value });
  }




  render() {
    if (this.state.sermons) {
      var sermons = _.map(this.state.sermons, (sermon) => {
        return (
          <tr key={_.uniqueId()}>
            <td className="col-md-3">{decode(sermon.node_title)}</td>
            <td className="col-md-2">{sermon.text ? decode(sermon.text) : ''}</td>
            <td className="col-md-2">{sermon.sermonseries ? decode(sermon.sermonseries) : ''}</td>
            <td className="col-md-2">{decode(sermon.preacher)}</td>
            <td className="col-md-2">{sermon.datepreached}</td>
            <td className="col-md-1"><i className="fa fa-file-audio-o" aria-hidden="true"></i><a href={sermon.url} target="_blank" rel="noopener noreferrer"> Listen</a></td>
          </tr>
        )
      });
    }

    var sermonTable;
    if (this.state.sermons) {
      sermonTable = (
        <Table responsive striped bordered condensed hover>
          <thead>
            <tr>
              <th></th>
              <th>Passage</th>
              <th>Sermon Series</th>
              <th>Preacher</th>
              <th>Date Preached</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sermons}
          </tbody>
        </Table>
      );
    }
    else {
      sermonTable = <div>Loading Sermons...</div>
    }



    let prevSermonsLink = null;
    if (this.state.page !== 0 && this.state.viewingRefinedList === false) {
      //eslint-disable-next-line
      prevSermonsLink = <a href="javascript:void(0);" onClick={() => this.loadPreviousSermons(this.state.page)}>Previous Page</a>
    }

    if (this.state.viewingRefinedList === true) {
      //eslint-disable-next-line
      prevSermonsLink = <a href="javascript:void(0);" onClick={() => this.loadPreviousSermons(1)}>Return to All Sermons</a>
    }

    let nextSermonsLink = null;
    if (this.state.page !== this.state.sermonPages - 1 && this.state.viewingRefinedList === false) {
      //eslint-disable-next-line
      nextSermonsLink = <a href="javascript:void(0);" onClick={() => this.loadNextSermons(this.state.page)}>Next Page</a>
    }

    var sermonSeriesOptions;
    if (this.state.sermonSeries) {
      sermonSeriesOptions = _.map(this.state.sermonSeries, (sermonSeries) => {
        return (
          <option key={sermonSeries.nid} value={sermonSeries.nid}>{decode(sermonSeries.node_title)}</option>
        )
      });
    }

    var showPageNumber;
    if (this.state.viewingRefinedList === false && this.state.sermonPages) {
      showPageNumber = <div className="text-center">Page {this.state.page + 1} of {this.state.sermonPages}</div>
    }

    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Sermons</h1>
          </div>
        </header>

        <section className="container">

          <span className="col-md-3">View Sermon Series:<select className="form-control" id="sermonSelect" onChange={event => this.loadSermonSeries(event.target.value)}>
            <option value="">---</option>
            {sermonSeriesOptions}
          </select></span>

          <div className="form-group">
            <form onSubmit={(e) => this.searchSermons(e)}>
              <div className="col-md-4">
                Search: <input type="text" className="form-control" id="searchQuery" value={this.state.searchQuery} onChange={(e) => this.updateSearchQuery(e)} />
              </div>
              <div className="col-md-3">
                In:
                <select className="form-control" id="searchType" value={this.state.searchType} onChange={(e) => this.updateSearchType(e)}>
                  <option value="title">Title</option>
                  <option value="preacher">Preacher</option>
                  <option value="passage">Bible Passage</option>
                </select>
              </div>
              <br />
              <input type="submit" value="Search" className="btn btn-primary" />
            </form>
          </div>


          {sermonTable}

          <span style={{ float: "left" }}>{prevSermonsLink}</span>
          <span style={{ float: "right" }}>{nextSermonsLink}</span>
          {showPageNumber}

          <br /><br />
          <div className="col-md-6">
            <a href="https://itunes.apple.com/au/podcast/christian-reformed-church-of-kingston/id936090108?mt=2" target="_blank" rel="noopener noreferrer"><button type="button" className="btn btn-primary"><i className="fa fa-podcast" aria-hidden="true"></i> Subscribe to Our Podcast</button></a>
          </div>
          {/* <div className="col-md-6">
            <a style={{ float: "right" }} className="noFloatRightMobile" href="ftp://sermons.crckingston.org.au/Sermons" target="_blank" rel="noopener noreferrer"><button type="button" className="btn btn-primary">Click here for Older Sermons</button></a>
          </div> */}



        </section>
      </section>
    );
  }
}

export default Sermons;
